import { render, staticRenderFns } from "./oldstuffhot.vue?vue&type=template&id=6d64a3e8"
import script from "./oldstuffhot.vue?vue&type=script&lang=js"
export * from "./oldstuffhot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports